import { createSlice } from "@reduxjs/toolkit";

const categorySlice = createSlice({
    name: "category",
    initialState: {
        data: [],
        categories: [],
        page: 1,
        pages: 1,
    },
    reducers: {
        setCategories(state, action) {
            const data = action.payload;
            state.categories = data.results;
            state.data = data.results;
            state.pages = data.pages;
        },
        setPage(state, action) {
            const page = action.payload;
            state.page = page;
        },
        filterDataByName(state, action) {
            const value = action.payload;
            if (!value || value === "") {
                state.categories = state.data;
            } else {
                const filteredData = state.data.filter((category) =>
                    category.name.toLowerCase().includes(value.toLowerCase()),
                );
                state.categories = filteredData;
            }
        },
    },
});

export const { setCategories, setPage, filterDataByName } = categorySlice.actions;

export default categorySlice;
